export function setPosTop() {
  if (!document.body.classList.contains('is-set-top')) {
    const scTop =
      (document.documentElement && document.documentElement.scrollTop) ||
      document.body.scrollTop
    const header = document.querySelector('.header')
    document.body.dataset.posTop = scTop
    if (header.classList.contains('is-fixed')) {
      document.body.dataset.isFixed = 'true'
    } else {
      document.body.dataset.isFixed = 'false'
    }
    document.body.classList.add(`is-set-top`)
  }
}
export function resetPosTop() {
  if (document.body.classList.contains('is-set-top')) {
    const currentTop = document.body.dataset.posTop
    const header = document.querySelector('.header')
    if (document.body.dataset.isFixed == 'false') {
      setTimeout(() => {
        header.classList.remove('is-fixed')
        document.body.removeAttribute('data-is-fixed')
      }, 0)
    }
    window.scrollTo(0, currentTop)
    document.body.removeAttribute('data-pos-top')
    document.body.classList.remove(`is-set-top`)
  }
}
